module.exports = __webpack_public_path__ + "img/sheila-hicks.eb24ba65.png";